import React, { useRef, useEffect } from "react";
import SignatureCanvas from "react-signature-canvas";
import styled from "styled-components";
import { useSession } from "../../../authentications/SessionContext";
import { primaryColor } from "../../../utilities/colors";

const CanvasWrapper = styled.div`
  border: 1px solid #000;
  width: 400px;
  height: 200px;
  margin-bottom: 10px;
`;

const SignatureComponent = ({ base64Signature, disabled, setFieldValue }) => {
  const sigCanvas = useRef(null);
  const { sessionInfo } = useSession();
  const { isVTEX } = sessionInfo;

  // Load base64 signature into canvas when the prop changes
  useEffect(() => {
    if (sigCanvas.current && base64Signature) {
      const dataURL = `data:image/png;base64,${base64Signature}`;
      //   console.log("Loading signature:", dataURL);

      try {
        sigCanvas.current.fromDataURL(dataURL, {
          width: 400,
          height: 200,
        });
      } catch (error) {
        console.error("Failed to load base64 signature:", error);
      }
    } else {
      sigCanvas.current?.clear();
    }
  }, [base64Signature]);

  // Toggle edit mode
  useEffect(() => {
    if (disabled) {
      sigCanvas.current.off(); // Enable drawing
    } else {
      sigCanvas.current.on(); // Disable drawing
    }
  }, [disabled]);

  // Handle signature change and update Formik's state
  const handleCanvasChange = () => {
    const dataURL = sigCanvas.current.toDataURL();
    const base64Data = dataURL.replace(/^data:image\/png;base64,/, "");
    // console.log("first2222", base64Data);
    setFieldValue("digital_signature", base64Data);
  };

  const handleClear = (e) => {
    e.preventDefault();
    sigCanvas.current.clear();
    setFieldValue("digital_signature", ""); // Clear Formik field value
  };

  return (
    <div>
      <CanvasWrapper>
        <SignatureCanvas
          ref={sigCanvas}
          penColor="black"
          onEnd={handleCanvasChange}
          canvasProps={{
            width: 400,
            height: 200,
            className: "sigCanvas",
          }}
        />
      </CanvasWrapper>

      <button
        className="btn btn-vtex"
        onClick={(e) => handleClear(e)}
        disabled={disabled}
        style={{
          background: "#000000",
          color: primaryColor.primary,
        }}
      >
        Clear
      </button>
    </div>
  );
};

export default SignatureComponent;
